import { Check } from "lucide-react";
import { APPLICANT_JOURNEY } from "../lib/statuses";

// Maps every backend status onto the linear applicant journey index.
const JOURNEY_INDEX = {
  "Application Received": 0,
  "Pre-Screen Invitation Sent": 0,
  "Pre-Screen In Progress": 1,
  "Pre-Screen Submitted": 2,
  "Additional Information Requested": 1,
  "Administrative Review": 3,
  "Approved to Advance": 4,
  "Not Selected to Advance": 3,
  "Training Access Granted": 5,
  "Training In Progress": 6,
  "Training Completed": 7,
  "Ready for Final Interview/Onboarding": 8,
  "Hired — Onboarding": 9,
  "Onboarding Complete": 10,
};

export function ProgressTracker({ status }) {
  const current = JOURNEY_INDEX[status] ?? 0;
  const declined = status === "Not Selected to Advance";

  return (
    <div data-testid="progress-tracker">
      {APPLICANT_JOURNEY.map((step, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <div key={step} className="flex gap-3">
            <div className="flex flex-col items-center">
              <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border text-xs font-semibold transition-colors
                ${done ? "border-[#3A7D5E] bg-[#3A7D5E] text-white"
                  : active ? "border-[#2C5545] bg-[#2C5545] text-white"
                  : "border-[#E5E2DC] bg-white text-[#515E58]"}`}>
                {done ? <Check className="h-4 w-4" /> : i + 1}
              </div>
              {i < APPLICANT_JOURNEY.length - 1 && (
                <div className={`w-px flex-1 ${done ? "bg-[#3A7D5E]" : "bg-[#E5E2DC]"}`} style={{ minHeight: 24 }} />
              )}
            </div>
            <div className="pb-6">
              <div className={`text-sm ${active ? "font-semibold text-[#1F2924]" : done ? "text-[#1F2924]" : "text-[#515E58]"}`}>
                {step}
              </div>
              {active && !declined && <div className="text-xs text-[#2C5545]">Current step</div>}
            </div>
          </div>
        );
      })}
      {declined && (
        <div className="mt-2 rounded-lg border border-[#C44F4F]/30 bg-[#FBEDED] p-3 text-sm text-[#C44F4F]">
          Application status: Not Selected to Advance
        </div>
      )}
    </div>
  );
}
